<ng-container *transloco="let t; read: 'ime.common.specs'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left">
      <svg viewBox="0 0 8 8" class="icon text-warning" inlineSVG="#exclamation-triangle">
      </svg>
      {{t('Saving property')}} {{property.DisplayName}}
    </h4>
    <button type="button" class="btn-close pull-right" aria-label="Close" (click)="close(false)">
    </button>
  </div>
  <div class="modal-body">
    <span>{{t('Changing this specification may corrupt existing IME and resource settings')}}. {{t('The specification is used in the following entities:')}}</span>
    <div *ngFor="let usageType of allUsageTypes" class="card mt-4">
      <div class="card-body">
        <h5 class="card-title">{{usageType.TranslationKey}}</h5>
        <span *ngFor="let u of usageType.Instances; let idx = index"
              title="{{idx == 10 ? '' : u.Name ? u.Name : u.Id}}"
              class="badge bg-{{idx == 10 ? 'default' : 'primary'}} me-1 text-wrap text-break text-start"
              data-toggle="{{idx == 10 ? '' : 'tooltip'}}" data-placement="top">
          {{idx == 10 ? '...' : u.Code}}
        </span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="text-end">
      <button type="button" class="btn btn-outline-primary" (click)="close(true)">
        {{t('Save')}}
      </button>
      <button type="button" class="btn btn-outline-default ms-2" (click)="close(false)">
        {{t('Cancel')}}
      </button>
    </div>
  </div>
</ng-container>
